import isEmail from 'validator/lib/isEmail';
import isLength from 'validator/lib/isLength';
import matches from 'validator/lib/matches';
import throttle from 'lodash.throttle';

import ApiService from 'services/ApiService/ApiService';
import { VALIDATE_EMAIL, GUEST_BILLING_VALIDATE_USERNAME_REGISTRATION_URL } from 'pages/User/Api';
import { passwordErrorMsgSignIn } from 'utils/helpers';
import { MAX_USERNAME_LENGTH, MIN_USERNAME_LENGTH } from 'enum/inputs';


function validateUsername(value) {
  return matches(value, /^[a-z0-9_]+$/i) && isLength(value, { min: MIN_USERNAME_LENGTH, max: MAX_USERNAME_LENGTH });
}

function validateEmail(value) {
  return isEmail(value);
}


function getCheckAvailability(currentState, URL, callback, property) {
  const { value } = currentState;
  const params = { [property]: value };
  ApiService.get(URL, { params }).then(
    () => {
      const isValid = true;
      let message = '';

      switch (property) {
        case 'username':
          message = 'profile.profile.userName.error.ok';
          break;

        case 'email':
          message = 'profile.profile.email.error.ok';
          break;

        default:
      }

      callback?.(property, isValid, message, currentState, true);
    },
    () => {
      const isValid = false;
      let message = '';

      switch (property) {
        case 'username':
          message = 'profile.profile.username.error.taken';
          break;

        case 'email':
          message = 'profile.profile.email.error.exists';
          break;

        default:
      }
      callback?.(property, isValid, message, currentState, true);
    }
  );

}


const throttled = throttle((currentState, callback = {}, property) => {
  let message = '';
  let isValid = undefined;
  const { value } = currentState;

  switch (property) {
    case 'username':
      isValid = validateUsername(value);

      switch (true) {
        case value === '':
          message = 'profile.profile.username.error.empty';
          break;

        case !isValid:
          message = 'profile.profile.username.error.invalid';
          break;

        default:
      }

      if (!isValid) {
        callback(property, isValid, message, currentState);
      } else {
        getCheckAvailability(currentState, GUEST_BILLING_VALIDATE_USERNAME_REGISTRATION_URL, callback, property);
      }
      break;

    case 'email':
      isValid = validateEmail(value);

      switch (true) {
        case value === '':
          message = 'profile.profile.email.error.empty';
          break;

        case !isValid:
          message = 'profile.profile.email.error.invalid';
          break;

        default:
      }

      if (!isValid) {
        callback(property, isValid, message, currentState);
      } else {
        getCheckAvailability(currentState, VALIDATE_EMAIL, callback, property);
      }
      break;

    default:
  }
}, 100);

export default {
  username: (currentState, callback = {}) => {
    throttled(currentState, callback, 'username');
  },
  password: (currentState, callback = {}, username) => {
    const res = passwordErrorMsgSignIn(currentState.value, username);

    callback('password', res.isValid, res.text, currentState);
  },
  email: (value, callback = {}) => {
    throttled(value, callback, 'email');
  },
};
